import { useAuthStore } from '../store/authStore';

/**
 * Convenience hook around the auth store.
 * Exposes the most-needed values plus a derived `isAuthed` boolean.
 */
export function useAuth() {
  const firebaseUser = useAuthStore((s) => s.firebaseUser);
  const appUser = useAuthStore((s) => s.appUser);
  const role = useAuthStore((s) => s.role);
  const isLoading = useAuthStore((s) => s.isLoading);
  const error = useAuthStore((s) => s.error);
  const signOut = useAuthStore((s) => s.signOut);
  const setAppUser = useAuthStore((s) => s.setAppUser);

  return {
    firebaseUser,
    appUser,
    role,
    isLoading,
    error,
    signOut,
    setAppUser,
    isAuthed: firebaseUser !== null,
  };
}
